import request from '@/utils/request'

// 变成已读事件
export function yidu(data) {
  return request({
    url: '/iotdevice/record',
    method: 'put',
    data: data
  })
}